export interface MangaCategory {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export interface MangaChapter {
  number: number;
  title: string;
  updateDate: string;
}

export interface Manga {
  id: string;
  title: string;
  cover: string;
  author: string;
  category: string;
  description: string;
  chapters: MangaChapter[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateDate: string;
  tags: string[];
}

export const categories: MangaCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', count: 48 },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 12 },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line', count: 8 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 7 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 6 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 5 },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', count: 5 },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', count: 3 },
  { slug: 'mature', name: '都市', icon: 'ri-building-line', count: 2 },
];

export const mangaList: Manga[] = [
  {
    id: 'secret-class',
    title: '秘密教学',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20drama%2C%20two%20characters%20close%20together%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20illustration%20style%2C%20soft%20warm%20lighting%2C%20modern%20aesthetic%2C%20emotional%20atmosphere%2C%20youth%20romance%20theme&width=600&height=800&seq=manga-secret-class&orientation=portrait',
    author: 'Ntree',
    category: 'romance',
    description: '从小一起长大的青梅竹马，却在某一天发现了彼此不为人知的秘密。一段关于青春、成长与懵懂爱情的故事就此展开。在韩漫漫画网，完整呈现原汁原味的故事情节，无任何删减修改。',
    chapters: [
      { number: 1, title: '第一话：青梅竹马', updateDate: '2026-08-01' },
      { number: 2, title: '第二话：不为人知的秘密', updateDate: '2026-08-02' },
      { number: 3, title: '第三话：心跳加速', updateDate: '2026-08-03' },
    ],
    status: '连载中',
    rating: 9.5,
    views: 1285000,
    updateDate: '2026-08-05',
    tags: ['恋爱', '校园', '青春', '甜宠'],
  },
  {
    id: 'solo-leveling',
    title: '我独自升级',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20action%20fantasy%2C%20dark%20warrior%20with%20shadow%20army%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20style%2C%20dark%20atmosphere%2C%20powerful%20character%20pose%2C%20fantasy%20action%20theme&width=600&height=800&seq=manga-solo-leveling&orientation=portrait',
    author: 'Chugong',
    category: 'action',
    description: '在一个突然出现"门"与怪物的世界里，最弱猎人成振宇在一次意外中获得了可以无限成长的独特能力，从此踏上了升级之路。韩漫漫画网为您呈现这部经典韩漫的完整内容。',
    chapters: [
      { number: 1, title: '第一话：最弱猎人', updateDate: '2026-07-20' },
      { number: 2, title: '第二话：双重地下城', updateDate: '2026-07-21' },
      { number: 3, title: '第三话：系统激活', updateDate: '2026-07-22' },
      { number: 4, title: '第四话：每日任务', updateDate: '2026-07-23' },
    ],
    status: '已完结',
    rating: 9.8,
    views: 3580000,
    updateDate: '2026-07-23',
    tags: ['热血', '奇幻', '战斗', '升级'],
  },
  {
    id: 'queen-bee',
    title: '女王蜂',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20drama%20romance%2C%20mysterious%20woman%20character%2C%20elegant%20style%2C%20Korean%20webtoon%20illustration%2C%20sophisticated%20atmosphere%2C%20dark%20undertones%2C%20mature%20theme%2C%20high%20quality%20art&width=600&height=800&seq=manga-queen-bee&orientation=portrait',
    author: 'HNB',
    category: 'drama',
    description: '权力与欲望交织的世界里，一个女人如何在这场游戏中生存？错综复杂的人际关系，环环相扣的故事情节，韩漫漫画网完整呈现这部引人入胜的韩漫佳作。',
    chapters: [
      { number: 1, title: '第一话：命运的齿轮', updateDate: '2026-08-03' },
      { number: 2, title: '第二话：暗流涌动', updateDate: '2026-08-04' },
    ],
    status: '连载中',
    rating: 9.2,
    views: 980000,
    updateDate: '2026-08-04',
    tags: ['剧情', '复仇', '黑道', '女性主角'],
  },
  {
    id: 'tower-of-god',
    title: '神之塔',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20fantasy%20adventure%2C%20mysterious%20tower%2C%20boy%20climbing%20tower%2C%20Korean%20webtoon%20art%20style%2C%20epic%20fantasy%2C%20vibrant%20colors%2C%20adventure%20theme%2C%20mystical%20atmosphere&width=600&height=800&seq=manga-tower-of-god&orientation=portrait',
    author: 'SIU',
    category: 'fantasy',
    description: '只要登顶神之塔，任何愿望都可以实现。少年夜为了追寻唯一的朋友蕾哈尔，义无反顾地进入了这座神秘的塔。韩漫漫画网完整收录，无删减下拉式阅读体验。',
    chapters: [
      { number: 1, title: '第一话：塔之门', updateDate: '2026-07-15' },
      { number: 2, title: '第二话：第一层试炼', updateDate: '2026-07-16' },
      { number: 3, title: '第三话：竞争者', updateDate: '2026-07-17' },
    ],
    status: '连载中',
    rating: 9.6,
    views: 4200000,
    updateDate: '2026-08-02',
    tags: ['冒险', '奇幻', '战斗', '成长'],
  },
  {
    id: 'villainess-reverse',
    title: '恶役大小姐的逆袭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20romance%20fantasy%2C%20elegant%20noble%20woman%2C%20royal%20setting%2C%20Korean%20webtoon%20style%2C%20romantic%20atmosphere%2C%20palace%20background%2C%20love%20story%20theme%2C%20beautiful%20dress&width=600&height=800&seq=manga-villainess&orientation=portrait',
    author: 'ROHA',
    category: 'romance',
    description: '穿越成为小说中的恶役大小姐，为了改变悲惨结局，她决定改写自己的命运。却意外引发了一连串意想不到的事件。韩漫漫画网带您走进精彩的异世界恋爱故事。',
    chapters: [
      { number: 1, title: '第一话：成为恶役', updateDate: '2026-08-05' },
    ],
    status: '连载中',
    rating: 9.0,
    views: 756000,
    updateDate: '2026-08-05',
    tags: ['穿越', '恋爱', '宫廷', '轻松'],
  },
  {
    id: 'lookism',
    title: '外貌至上主义',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20school%20drama%2C%20two%20different%20looking%20male%20characters%2C%20Korean%20webtoon%20art%2C%20youth%20theme%2C%20social%20commentary%2C%20modern%20setting%2C%20dynamic%20pose&width=600&height=800&seq=manga-lookism&orientation=portrait',
    author: '朴泰俊',
    category: 'drama',
    description: '一个因为外貌受尽欺凌的高中生，某天醒来发现自己拥有了另一个完美的身体。白天是帅气男神，晚上变回原来的自己。韩漫漫画网带您探讨外貌与内在的真谛。',
    chapters: [
      { number: 1, title: '第一话：两个身体', updateDate: '2026-07-28' },
      { number: 2, title: '第二话：新生活', updateDate: '2026-07-29' },
    ],
    status: '连载中',
    rating: 9.3,
    views: 2100000,
    updateDate: '2026-08-01',
    tags: ['校园', '剧情', '社会', '双面人生'],
  },
  {
    id: 'sweet-home',
    title: '甜蜜家园',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20horror%20thriller%2C%20apartment%20building%2C%20monster%20theme%2C%20Korean%20webtoon%20style%2C%20dark%20atmosphere%2C%20survival%20horror%2C%20tense%20mood%2C%20scary%20elements&width=600&height=800&seq=manga-sweet-home&orientation=portrait',
    author: '金坎比',
    category: 'horror',
    description: '怪物突然出现，人们被困在公寓里。人性的黑暗与光辉在绝境中被放大。韩漫漫画网完整收录这部经典惊悚韩漫，无删减原汁原味呈现。',
    chapters: [
      { number: 1, title: '第一话：怪物', updateDate: '2026-07-10' },
      { number: 2, title: '第二话：隔离', updateDate: '2026-07-11' },
    ],
    status: '已完结',
    rating: 9.4,
    views: 1800000,
    updateDate: '2026-07-11',
    tags: ['惊悚', '生存', '怪物', '人性'],
  },
  {
    id: 'business-proposal',
    title: '社内相亲',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20office%20romance%2C%20elegant%20couple%2C%20Korean%20webtoon%20style%2C%20romantic%20comedy%2C%20business%20setting%2C%20warm%20atmosphere%2C%20love%20story%20theme&width=600&height=800&seq=manga-business-proposal&orientation=portrait',
    author: '海华',
    category: 'comedy',
    description: '代替闺蜜去相亲，却发现对象竟然是公司的社长！一场啼笑皆非的办公室恋情就此展开。韩漫漫画网带您感受甜蜜办公室恋爱喜剧。',
    chapters: [
      { number: 1, title: '第一话：代相亲', updateDate: '2026-08-04' },
      { number: 2, title: '第二话：他是社长', updateDate: '2026-08-05' },
    ],
    status: '连载中',
    rating: 9.1,
    views: 890000,
    updateDate: '2026-08-05',
    tags: ['喜剧', '恋爱', '办公室', '甜宠'],
  },
  {
    id: 'god-of-high-school',
    title: '高校之神',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20martial%20arts%20action%2C%20high%20school%20fighter%2C%20dynamic%20pose%2C%20Korean%20webtoon%20style%2C%20intense%20battle%2C%20tournament%20theme%2C%20energy%20effects%2C%20exciting%20atmosphere&width=600&height=800&seq=manga-god-of-highschool&orientation=portrait',
    author: '朴溶济',
    category: 'action',
    description: '全国高中生格斗大赛开幕，各路高手齐聚一堂。这是一场关于力量、信念与友情的较量。韩漫漫画网完整收录，下拉式流畅阅读。',
    chapters: [
      { number: 1, title: '第一话：大赛开幕', updateDate: '2026-07-05' },
      { number: 2, title: '第二话：第一战', updateDate: '2026-07-06' },
      { number: 3, title: '第三话：觉醒', updateDate: '2026-07-07' },
    ],
    status: '连载中',
    rating: 9.3,
    views: 1650000,
    updateDate: '2026-08-03',
    tags: ['格斗', '校园', '热血', '友情'],
  },
  {
    id: 'true-beauty',
    title: '女神降临',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20beauty%20makeup%20theme%2C%20transformation%20story%2C%20Korean%20webtoon%20style%2C%20romantic%20school%20drama%2C%20pretty%20girl%2C%20shy%20expression%2C%20youth%20theme&width=600&height=800&seq=manga-true-beauty&orientation=portrait',
    author: 'Yaongyi',
    category: 'romance',
    description: '因外貌自卑的女孩通过化妆技术华丽变身，成为校园女神。但真实的自己与伪装的身份之间的冲突让她左右为难。韩漫漫画网呈现最真实的青春成长故事。',
    chapters: [
      { number: 1, title: '第一话：素颜的烦恼', updateDate: '2026-07-25' },
      { number: 2, title: '第二话：化妆的力量', updateDate: '2026-07-26' },
    ],
    status: '已完结',
    rating: 9.4,
    views: 2900000,
    updateDate: '2026-07-26',
    tags: ['恋爱', '校园', '成长', '美容'],
  },
  {
    id: 'noblesse',
    title: 'Noblesse',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20vampire%20noble%2C%20elegant%20male%20character%2C%20dark%20fantasy%2C%20Korean%20webtoon%20style%2C%20mysterious%20atmosphere%2C%20gothic%20theme%2C%20powerful%20aura&width=600&height=800&seq=manga-noblesse&orientation=portrait',
    author: '孙齐皓',
    category: 'fantasy',
    description: '沉睡了820年的贵族吸血鬼醒来后，决定融入现代社会，成为一名普通的高中生。然而他的身份注定无法平凡。韩漫漫画网完整收录这部经典奇幻韩漫。',
    chapters: [
      { number: 1, title: '第一话：苏醒', updateDate: '2026-07-01' },
      { number: 2, title: '第二话：转学生', updateDate: '2026-07-02' },
    ],
    status: '已完结',
    rating: 9.5,
    views: 3100000,
    updateDate: '2026-07-02',
    tags: ['吸血鬼', '校园', '奇幻', '战斗'],
  },
  {
    id: 'kill-the-hero',
    title: '杀死英雄',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20revenge%20thriller%2C%20dark%20male%20protagonist%2C%20Korean%20webtoon%20style%2C%20intense%20atmosphere%2C%20action%20theme%2C%20dramatic%20lighting%2C%20antihero%20concept&width=600&height=800&seq=manga-kill-hero&orientation=portrait',
    author: 'Ppangddeok',
    category: 'thriller',
    description: '被最信任的同伴背叛杀害后，他重生了。这一次，他要向所有人复仇。步步为营，精心策划的复仇计划。韩漫漫画网完整呈现这部复仇爽漫。',
    chapters: [
      { number: 1, title: '第一话：背叛', updateDate: '2026-08-02' },
      { number: 2, title: '第二话：重生', updateDate: '2026-08-03' },
    ],
    status: '连载中',
    rating: 9.2,
    views: 1120000,
    updateDate: '2026-08-04',
    tags: ['复仇', '重生', '战斗', '暗黑'],
  },
  {
    id: 'age-of-innocence',
    title: '纯净年代',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20youth%20romance%2C%20two%20teenagers%20in%20school%20uniform%2C%20Korean%20webtoon%20style%2C%20warm%20nostalgic%20atmosphere%2C%20first%20love%20theme%2C%20clean%20simple%20background&width=600&height=800&seq=manga-age-of-innocence&orientation=portrait',
    author: '余韵',
    category: 'romance',
    description: '在那个纯真的年代，一段青涩的初恋悄然萌芽。没有华丽辞藻，只有最真实的青春悸动。韩漫漫画网邀您一同回味那段美好的纯净年代。',
    chapters: [
      { number: 1, title: '第一话：初见', updateDate: '2026-07-30' },
    ],
    status: '连载中',
    rating: 8.9,
    views: 456000,
    updateDate: '2026-07-30',
    tags: ['青春', '恋爱', '校园', '治愈'],
  },
  {
    id: 'hive',
    title: '虫穴',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20survival%20horror%2C%20giant%20insects%2C%20apocalyptic%20setting%2C%20Korean%20webtoon%20style%2C%20dark%20mood%2C%20survival%20theme%2C%20intense%20atmosphere&width=600&height=800&seq=manga-hive&orientation=portrait',
    author: '金奎三',
    category: 'horror',
    description: '巨型昆虫突然出现，人类文明岌岌可危。一个普通上班族如何在末日中保护家人？韩漫漫画网完整收录，惊险刺激的生存故事。',
    chapters: [
      { number: 1, title: '第一话：巨虫来袭', updateDate: '2026-06-20' },
      { number: 2, title: '第二话：逃亡', updateDate: '2026-06-21' },
      { number: 3, title: '第三话：避难所', updateDate: '2026-06-22' },
    ],
    status: '已完结',
    rating: 9.0,
    views: 1450000,
    updateDate: '2026-06-22',
    tags: ['生存', '怪物', '末日', '家庭'],
  },
  {
    id: 'leviathan',
    title: '深海巨兽',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20ocean%20monster%2C%20sea%20creature%2C%20dark%20water%2C%20Korean%20webtoon%20style%2C%20horror%20fantasy%2C%20deep%20sea%20theme%2C%20mysterious%20atmosphere&width=600&height=800&seq=manga-leviathan&orientation=portrait',
    author: '李贤民',
    category: 'fantasy',
    description: '当海平面上升淹没大陆，人类在海上艰难求生。而深海中，还有更可怕的生物在等待。韩漫漫画网完整呈现这部宏大的海洋奇幻冒险。',
    chapters: [
      { number: 1, title: '第一话：沉没的世界', updateDate: '2026-07-12' },
      { number: 2, title: '第二话：深海猎人', updateDate: '2026-07-13' },
    ],
    status: '连载中',
    rating: 9.3,
    views: 1200000,
    updateDate: '2026-08-01',
    tags: ['海洋', '怪物', '冒险', '生存'],
  },
  {
    id: 'bastard',
    title: '不肖子',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20psychological%20thriller%2C%20dark%20atmosphere%2C%20tense%20mood%2C%20Korean%20webtoon%20style%2C%20father%20and%20son%20theme%2C%20mystery%2C%20suspenseful&width=600&height=800&seq=manga-bastard&orientation=portrait',
    author: '金坎比',
    category: 'thriller',
    description: '父亲是连环杀手，儿子是唯一的知情者。当新来的转学生成为父亲的下一个目标，儿子必须做出选择。韩漫漫画网完整收录这部心理惊悚神作。',
    chapters: [
      { number: 1, title: '第一话：父亲的秘密', updateDate: '2026-06-15' },
      { number: 2, title: '第二话：转学生', updateDate: '2026-06-16' },
      { number: 3, title: '第三话：抉择', updateDate: '2026-06-17' },
      { number: 4, title: '第四话：反抗', updateDate: '2026-06-18' },
    ],
    status: '已完结',
    rating: 9.7,
    views: 2500000,
    updateDate: '2026-06-18',
    tags: ['悬疑', '惊悚', '心理', '犯罪'],
  },
  {
    id: 'wind-breaker',
    title: '极速车魂',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20cycling%20sports%2C%20dynamic%20action%2C%20Korean%20webtoon%20style%2C%20youth%20sports%2C%20racing%20theme%2C%20energetic%20atmosphere%2C%20competition&width=600&height=800&seq=manga-wind-breaker&orientation=portrait',
    author: '赵容石',
    category: 'action',
    description: '热爱自行车运动的少年们，在赛道上挥洒汗水与青春。速度、激情与友情的故事。韩漫漫画网完整呈现这部热血运动韩漫。',
    chapters: [
      { number: 1, title: '第一话：风速少年', updateDate: '2026-07-18' },
      { number: 2, title: '第二话：初赛', updateDate: '2026-07-19' },
    ],
    status: '连载中',
    rating: 9.1,
    views: 980000,
    updateDate: '2026-08-03',
    tags: ['运动', '竞技', '热血', '友情'],
  },
  {
    id: 'eleceed',
    title: '异能者',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20superpower%20action%2C%20cat%20companion%2C%20Korean%20webtoon%20style%2C%20fantasy%20action%2C%20bright%20colors%2C%20humorous%20tone%2C%20superhero%20theme&width=600&height=800&seq=manga-eleceed&orientation=portrait',
    author: '孙齐皓',
    category: 'comedy',
    description: '拥有超能力的高中生和他的猫系导师，一边对抗邪恶势力一边成长的搞笑热血故事。韩漫漫画网完整收录，轻松愉快的阅读体验。',
    chapters: [
      { number: 1, title: '第一话：觉醒', updateDate: '2026-08-01' },
      { number: 2, title: '第二话：猫导师', updateDate: '2026-08-02' },
    ],
    status: '连载中',
    rating: 9.4,
    views: 1850000,
    updateDate: '2026-08-05',
    tags: ['超能力', '喜剧', '热血', '成长'],
  },
];

export const hotMangaIds = ['secret-class', 'solo-leveling', 'queen-bee', 'tower-of-god', 'eleceed', 'bastard'];

export const latestMangaIds = ['secret-class', 'queen-bee', 'villainess-reverse', 'business-proposal', 'eleceed', 'kill-the-hero', 'wind-breaker', 'god-of-high-school'];